/* tslint:disable */
/* eslint-disable */
/**
 * Gestionale.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TipoTrattamentoUpdateDTO
 */
export interface TipoTrattamentoUpdateDTO {
    /**
     * 
     * @type {string}
     * @memberof TipoTrattamentoUpdateDTO
     */
    descrizione: string;
}

/**
 * Check if a given object implements the TipoTrattamentoUpdateDTO interface.
 */
export function instanceOfTipoTrattamentoUpdateDTO(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "descrizione" in value;

    return isInstance;
}

export function TipoTrattamentoUpdateDTOFromJSON(json: any): TipoTrattamentoUpdateDTO {
    return TipoTrattamentoUpdateDTOFromJSONTyped(json, false);
}

export function TipoTrattamentoUpdateDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): TipoTrattamentoUpdateDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'descrizione': json['descrizione'],
    };
}

export function TipoTrattamentoUpdateDTOToJSON(value?: TipoTrattamentoUpdateDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'descrizione': value.descrizione,
    };
}

